// extracted by mini-css-extract-plugin
export default {"root":"ProductItems_root__1VaYZ","title":"ProductItems_title__2A2T_","items":"ProductItems_items__LLBHb"};